import { fetchDashboardAreaList } from '@/api/base/index';

const GET_AREA_LIST = 'GET_AREA_LIST';
const FETCH_STATE = 'FETCH_STATE';
const FETCH_END = 'FETCH_END';

const state = () => ({
  fetching: false,
  list: [],
});

const initGetters = () => ({
  dashboardArea: state => state.list,
  dashboardAreaFetching: state => state.fetching,
});
const getters = initGetters();

const initAction = () => ({
  fetchDashboardAreaList({ commit, state }, entity) {
    if (state.fetching) return;
    commit(FETCH_STATE);
    return fetchDashboardAreaList({
      data: entity,
      notLoading: true,
    })
      .then(res => {
        const list = res.data;
        commit(GET_AREA_LIST, list);
        commit(FETCH_END);
      })
      .catch(err => {
        commit(FETCH_END);
        throw err;
      });
  },
});
const actions = initAction();

const mutations = {
  [GET_AREA_LIST](state, list) {
    state.list = list;
  },
  [FETCH_STATE](state) {
    state.fetching = true;
  },
  [FETCH_END](state) {
    state.fetching = false;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
